import { addGesture, removeGesture } from 'store/actions/Gestures'

import store from '../index'

const { dispatch } = store

export const dispatchAddGesture = payload => dispatch(addGesture(payload))
export const dispatchRemoveGesture = payload => dispatch(removeGesture(payload))
